import { WordPressSources } from "../consts";
import { extractFromPTagsFromRawText, fetchMultiplePages } from "../utils";
export async function fetchPeople() {
    const json = await fetchMultiplePages(WordPressSources.people);
    const parsedData = [];
    // Convert each array item into the person type
    json.forEach(item => {
        parsedData.push({
            name: item.title.rendered,
            id: item.id,
            imageSrc: getPersonImageSource(item.content.rendered),
            position: extractFromPTagsFromRawText(item.content.rendered, "h2", "position"),
            UbcProfileLink: extractFromPTagsFromRawText(item.content.rendered, "h2", "ubc profile page"),
            email: extractFromPTagsFromRawText(item.content.rendered, "h2", "email"),
            googleScholarLink: extractFromPTagsFromRawText(item.content.rendered, "h2", "google scholar link"),
            details: parsePersonDetailsJSON(item.content.rendered)
        });
    });
    return parsedData;
}
// Parses the h3 tags and content from a WordPress Person page
function parsePersonDetailsJSON(json) {
    const regex = /<h3(.*?)>(.*?)<\/h3>(((\\[a-z])*?)|((\s)*?))(<p(.*?)>|<ul(.*?)>)(.*?)(<\/p>|<\/ul>)/gim;
    const matchedDetails = json.match(regex);
    if (matchedDetails == null)
        return;
    const parsedDetails = [];
    matchedDetails.forEach(element => {
        const parentElement = document.createElement('div');
        parentElement.innerHTML = element;
        const liTags = Array.from(parentElement.querySelectorAll("li"));
        parsedDetails.push({
            title: parentElement.querySelector("h3").innerHTML,
            text: (parentElement.querySelector("p")) ? parentElement.querySelector("p").innerHTML : null,
            list: liTags.map(li => li.innerHTML)
        });
    });
    return parsedDetails;
}
// Cleanly extracts src attribute from <img> tag in a WordPress Person page
function getPersonImageSource(rawString) {
    const regex = /<img[^>]+src=([^>]+)>/g;
    const imgString = rawString.match(regex);
    if (imgString == null)
        return;
    if (!Array.isArray(imgString))
        return;
    if (imgString.length < 1)
        return;
    let elem = document.createElement('div');
    elem.innerHTML = imgString[0];
    return elem.querySelector('img').src;
}
